<!--
  安全设置
  lovi 2020-1-13
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.securitySet')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('securitySet.mobileNumberManagement')"
            is-link
            :value="userInfo.phone"
            @click="_linkFun('/phoneManage')"
          />
          <van-cell
            :title="$t('securitySet.modifyLoginPsd')"
            is-link
            @click="_linkFun('/modifyPsd')"
          />
          <van-cell
            :title="$t('securitySet.paySet')"
            is-link
            @click="_linkFun('/paySet')"
          />
          <van-cell
            :title="$t('securitySet.thirdPartyLogin')"
            is-link
            @click="_linkFun('/thirdParty')"
          />
          <van-cell
            :title="$t('securitySet.emailBinding')"
            :value="userInfo.email ? userInfo.email : $t('securitySet.unbound')"
            is-link
            @click="_linkFun('/email')"
          />
          <van-cell
            :title="$t('securitySet.securitySettings')"
            :value="
              userInfo.safe_question == 1
                ? $t('common.haveSet')
                : $t('common.notSet')
            "
            is-link
            @click="_linkFun('/encrypted')"
          />
        </van-cell-group>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "securitySet",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
